export default __webpack_public_path__ + "static/media/carousel-2.3cf1d945.png";